
document.documentElement.classList.remove('no-js');
class ExactProductGallery{constructor(root){this.root=root;this.items=[...root.querySelectorAll('[data-product-media]')];this.thumbs=[...root.querySelectorAll('[data-product-thumb]')];this.i=0;this.thumbs.forEach((b,i)=>b.addEventListener('click',()=>this.show(i)));root.querySelector('[data-product-prev]')?.addEventListener('click',()=>this.show(this.i-1));root.querySelector('[data-product-next]')?.addEventListener('click',()=>this.show(this.i+1));root.querySelector('[data-product-zoom]')?.addEventListener('click',()=>{const img=this.items[this.i]?.querySelector('img');if(img)this.zoom(img)});this.show(0)}show(n){if(!this.items.length)return;this.i=(n+this.items.length)%this.items.length;this.items.forEach((x,i)=>x.classList.toggle('is-active',i===this.i));this.thumbs.forEach((x,i)=>x.setAttribute('aria-current',i===this.i?'true':'false'));const c=this.root.querySelector('[data-product-count]');if(c)c.textContent=`${this.i+1} / ${this.items.length}`}zoom(img){let d=document.querySelector('#ThemeLightbox');if(!d){d=document.createElement('dialog');d.id='ThemeLightbox';d.className='lightbox';d.innerHTML='<button class="lightbox-close" aria-label="Close">×</button><img alt="">';document.body.append(d);d.querySelector('button').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d)d.close()})}d.querySelector('img').src=img.currentSrc||img.src;d.querySelector('img').alt=img.alt;d.showModal()}}
(function () {
  const prefetched = new Set();
  const prefetch = (anchor) => {
    if (!anchor || !anchor.href || prefetched.has(anchor.href)) return;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    prefetched.add(anchor.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.href = anchor.href;
    document.head.appendChild(hint);
  };
  document.addEventListener('pointerover', (event) => prefetch(event.target.closest('[data-route-prefetch]')), { passive: true });
  document.addEventListener('focusin', (event) => prefetch(event.target.closest('[data-route-prefetch]')));
})();

(function () {
  function hydrate(container) {
    if (!container) return null;
    var existing = container.querySelector(':scope > video');
    if (existing) return existing;
    var template = container.querySelector(':scope > template[data-video-template]');
    if (!template || !template.content) return null;
    var video = template.content.firstElementChild;
    if (!video) return null;
    video = video.cloneNode(true);
    video.preload = 'metadata';
    template.before(video);
    container.classList.add('is-hydrated');
    video.addEventListener('loadedmetadata', function () {
      if (!video.videoWidth || !video.videoHeight) return;
      var ratio = video.videoWidth / video.videoHeight;
      var containerRatio = container.clientWidth && container.clientHeight ? container.clientWidth / container.clientHeight : ratio;
      var ratioDifference = Math.max(ratio / containerRatio, containerRatio / ratio);
      container.classList.toggle('is-wide-video', ratio > 1.3);
      container.classList.toggle('is-tall-video', ratio < .9);
      container.classList.toggle('is-ratio-mismatch', ratioDifference > 1.14);
    }, { once: true });
    return video;
  }

  function pauseOutside(activeVideo) {
    document.querySelectorAll('video').forEach(function (video) {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  }

  window.CygnaxisMedia = { hydrate: hydrate, pauseOutside: pauseOutside };
})();

